import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Users } from "lucide-react";
import Overview from "./Pages/Overview";
import Campaigns from "./Pages/Campaigns";
import ReferredUsers from "./Pages/ReferredUsers";
import Commission from "./Pages/Commission";
import Faq from "./Pages/Faq";

import storage from "utils/Storage";

const PageGrid = styled.div`
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 24px;
  margin-top: 30px;
  align-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const SidebarNav = styled.aside`
  background-color: #292d2e;
  border: 1px solid rgba(58, 65, 66, 0.4);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: sticky;
  top: 80px;
  align-self: flex-start;

  @media (max-width: 992px) {
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    position: static;
    padding: 8px;
    gap: 8px;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const NavItem = styled.button`
  background-color: ${props => props.active ? "#3a4142" : "transparent"};
  color: ${props => props.active ? "#fff" : "#b9c4c7"};
  border: none;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background-color: ${props => props.active ? "#3a4142" : "rgba(58, 65, 66, 0.4)"};
  }

  @media (max-width: 992px) {
    text-align: center;
    padding: 8px 12px;
    font-size: 13px;
  }
`;

const ContentPanel = styled.section`
  min-width: 0;
`;

const PageWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;

  @media (max-width: 768px) {
    padding: 16px 10px !important;
  }
`;

const AfterLogin = () => {
  const history = useHistory();
  const location = useLocation();  
  const isLogged = !!storage.getKey('logged');

  const menuItems = isLogged ? [
    { text: 'Overview', route: '/affiliate' },
    { text: 'Campaigns', route: '/affiliate/campaigns' },
    { text: 'Commission', route: '/affiliate/commission' },
    { text: 'Referred Users', route: '/affiliate/referred-users' },
    { text: 'FAQ', route: '/affiliate/faq' },
  ] : [
    { text: 'Overview', route: '/affiliate' },
  ];

  const activeRoute = location.pathname;

  return (
    <PageWrapper>
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
        <Users size={28} color="#ffffff" style={{ strokeWidth: 2.5 }} />
        <h1 style={{ fontSize: "28px", fontWeight: "800", color: "#ffffff", margin: 0, letterSpacing: "-0.5px" }}>Affiliate Program</h1>
      </div>
      <PageGrid>
        <SidebarNav>
          {menuItems.map((item, index) => {
            const isActive = activeRoute === item.route;
            return (
              <NavItem
                key={index}
                active={isActive}
                onClick={() => history.push(item.route)}
              >
                {item.text}
              </NavItem>
            );
          })}
        </SidebarNav>

        <ContentPanel>
          {(!isLogged || activeRoute === '/affiliate') && <Overview />}
          {isLogged && activeRoute === '/affiliate/campaigns' && <Campaigns />}
          {isLogged && activeRoute === '/affiliate/commission' && <Commission />}
          {isLogged && activeRoute === '/affiliate/referred-users' && <ReferredUsers />}
          {isLogged && activeRoute === '/affiliate/faq' && <Faq />}
        </ContentPanel>
      </PageGrid>
    </PageWrapper>
  );
};

export default AfterLogin;
